import { computed, ref } from 'vue';

/** In-flight TTS provider generations (cache misses only — excludes cache hits / file fetches). */
const activeCount = ref(0);

/** True while ≥1 JiT clip is being generated via the TTS provider. Drives the mute-button AI indicator. */
export const isJitSynthesizing = computed(() => activeCount.value > 0);

/** Wrap the TTS-provider generation path so the UI can reflect "AI processing audio". */
export const trackJitSynthesisActive = async <T>(
  job: () => Promise<T>
): Promise<T> => {
  activeCount.value += 1;
  try {
    return await job();
  } finally {
    activeCount.value -= 1;
  }
};
